var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-set",
      class: [_vm.schema.sectionBgColor, _vm.schema.layout],
      style: _vm.sectionPaddingStyle,
      attrs: { id: "product-set-" + _vm.schema.collection }
    },
    [
      _c(
        "h3",
        {
          staticClass: "product-set__section-title container",
          class: _vm.schema.sectionTitleColor
        },
        [_vm._v(_vm._s(_vm.schema.sectionTitle))]
      ),
      _c("div", { staticClass: "product-set__container container" }, [
        _c("div", { staticClass: "product-set__collection-container" }, [
          _vm.schema.layout === "full"
            ? _c(
                "div",
                {
                  staticClass:
                    "product-set__collection product-set__collection--mobile-full",
                  class: _vm.schema.textBgColorMobile
                },
                [
                  _c(
                    "div",
                    { staticClass: "product-set__collection-content" },
                    [
                      _c(
                        "h5",
                        {
                          staticClass: "product-set__collection-title",
                          class: _vm.schema.textColor
                        },
                        [_vm._v(_vm._s(_vm.schema.collectionTitle))]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "product-set__collection-description",
                          class: _vm.schema.textColor
                        },
                        [_vm._v(_vm._s(_vm.schema.collectionDescription))]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "product-set__collection-cta-container"
                        },
                        [
                          _vm.schema.ctaLayout.includes("button")
                            ? _c(
                                "v-button",
                                {
                                  staticClass: "product-set__collection-cta",
                                  class: _vm.schema.ctaLayout,
                                  attrs: {
                                    href: _vm.schema.collectionUrl,
                                    tag: "a"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.schema.ctaText))]
                              )
                            : _vm._e(),
                          _vm.schema.ctaLayout.includes("link")
                            ? _c(
                                "v-link",
                                {
                                  staticClass: "product-set__collection-cta",
                                  class: _vm.schema.ctaLayout,
                                  attrs: { href: _vm.schema.collectionUrl }
                                },
                                [_vm._v(_vm._s(_vm.schema.ctaText))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "product-set__collection",
              style: _vm.collectionStyle(_vm.$mq)
            },
            [
              _vm.schema.enableOverlay
                ? _c("div", {
                    staticClass: "product-set__overlay",
                    class: _vm.schema.imageOverlayColor,
                    style: _vm.collectionOverlayStyle
                  })
                : _vm._e(),
              _c("div", { staticClass: "product-set__collection-content" }, [
                _c(
                  "h5",
                  {
                    staticClass: "product-set__collection-title",
                    class: _vm.schema.textColor
                  },
                  [_vm._v(_vm._s(_vm.schema.collectionTitle))]
                ),
                _c(
                  "p",
                  {
                    staticClass: "product-set__collection-description",
                    class: _vm.schema.textColor
                  },
                  [_vm._v(_vm._s(_vm.schema.collectionDescription))]
                ),
                _c(
                  "div",
                  { staticClass: "product-set__collection-cta-container" },
                  [
                    _vm.schema.ctaLayout.includes("button")
                      ? _c(
                          "v-button",
                          {
                            staticClass: "product-set__collection-cta",
                            class: _vm.schema.ctaLayout,
                            attrs: { href: _vm.schema.collectionUrl, tag: "a" }
                          },
                          [_vm._v(_vm._s(_vm.schema.ctaText))]
                        )
                      : _vm._e(),
                    _vm.schema.ctaLayout.includes("link")
                      ? _c(
                          "v-link",
                          {
                            staticClass: "product-set__collection-cta",
                            class: _vm.schema.ctaLayout,
                            attrs: { href: _vm.schema.collectionUrl }
                          },
                          [_vm._v(_vm._s(_vm.schema.ctaText))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]),
        _c(
          "div",
          { staticClass: "product-set__carousel-container" },
          [
            _c(
              "swiper",
              { ref: "carousel", attrs: { options: _vm.swiperOptions } },
              _vm._l(_vm.schema.products, function(product, idx) {
                return _c(
                  "swiper-slide",
                  { key: product.id, staticClass: "product-set__slide" },
                  [_c("product-tile-widget", { attrs: { product: product } })],
                  1
                )
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "product-set__carousel-controls-container" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "product-set__carousel-control product-set__carousel-control--next"
                  },
                  [
                    _c(
                      "v-arrow-button",
                      {
                        staticClass: "product-set__nav-button next",
                        attrs: { primary: true }
                      },
                      [
                        _c("icon", {
                          attrs: { name: "arrow-right", size: "24px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "product-set__carousel-control product-set__carousel-control--prev"
                  },
                  [
                    _c(
                      "v-arrow-button",
                      {
                        staticClass: "product-set__nav-button prev",
                        attrs: { primary: true }
                      },
                      [
                        _c("icon", {
                          attrs: { name: "arrow-right", size: "24px" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c("div", { staticClass: "product-set__pagination" })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }